<mg-checkout-options-layout
    [deal$]="configuration$"
    [layoutTrigger$]="layoutTrigger$"
    [modelName]="modelName$ | async"
    [routeIndex]="routeIndex"
    [withCarPreview]="(carPreviewFormFields$ | async).length"
>
    <ng-container mg-car-preview-fields>
        <ng-container *ngFor="let formField of carPreviewFormFields$ | async; trackBy: trackFormField">
            <div
                *ngIf="
                    (configuration$ | async) && (modelName$ | async) && formField.configurationOption.name === 'paint'
                "
                class="mobile-car-preview"
            >
                <mg-preview-tesla [deal$]="configuration$"></mg-preview-tesla>
            </div>

            <ng-container *ngIf="!formField.useCard">
                <ng-container *ngTemplateOutlet="formFieldTemplate; context: { formField: formField }"></ng-container>
            </ng-container>
        </ng-container>

        <ng-template #formFieldTemplate let-formField="formField">
            <p
                *ngIf="
                    { optionName: formField.configurationOption.name, key: 'optionDescription' }
                        | optionTranslation
                        | async as description
                "
            >
                {{ description }}
            </p>
            <ng-container
                *ngIf="formField.configurationOption.__typename === 'SelectableDealOption'"
                [ngSwitch]="formField.configurationOption.name"
            >
                <mg-configuration-option-select-advanced-edition
                    *ngSwitchCase="'edition'"
                    [configurationOption]="formField.configurationOption"
                    [formControl]="formField.formControl"
                ></mg-configuration-option-select-advanced-edition>
                <mg-configuration-option-select-advanced-rims
                    *ngSwitchCase="'rims'"
                    [configurationOption]="formField.configurationOption"
                    [formControl]="formField.formControl"
                ></mg-configuration-option-select-advanced-rims>
                <mg-configuration-option-select-advanced-color
                    *ngSwitchCase="'paint'"
                    [configurationOption]="formField.configurationOption"
                    [formControl]="formField.formControl"
                ></mg-configuration-option-select-advanced-color>
                <mg-configuration-option-select-advanced-steeringwheel
                    *ngSwitchCase="'steeringWheel'"
                    [configurationOption]="formField.configurationOption"
                    [formControl]="formField.formControl"
                ></mg-configuration-option-select-advanced-steeringwheel>
            </ng-container>
        </ng-template>
    </ng-container>

    <ng-container mg-remaining-fields>
        <ng-content select=".above-content"></ng-content>
        <ng-container *ngFor="let formField of remainingFormFields$ | async; trackBy: trackFormField">
            <mg-ui-card
                *ngIf="formField.useCard && !formField.optionKey.includes('accessory')"
                [attr.data-id]="formField.id"
                [attr.data-name]="formField.configurationOption.name"
                [subtitle]="
                    { optionName: formField.configurationOption.name, key: 'subtitle' } | optionTranslation | async
                "
                [subtitleLink]="
                    { optionName: formField.configurationOption.name, key: 'subtitleLink' } | optionTranslation | async
                "
                [subtitleLinkLabel]="
                    { optionName: formField.configurationOption.name, key: 'subtitleLinkLabel' }
                        | optionTranslation
                        | async
                "
                [title]="{ optionName: formField.configurationOption.name, key: 'title' } | optionTranslation | async"
            >
                <mg-ui-modal [keys]="[formField.configurationOption.name]">
                    <mat-icon class="configurator-icon-modal">info_outline</mat-icon>
                </mg-ui-modal>
                <ng-container *ngTemplateOutlet="remainingFormFieldTemplate; context: { formField: formField }">
                </ng-container>
            </mg-ui-card>

            <ng-container *ngIf="!formField.useCard">
                <ng-container
                    *ngTemplateOutlet="remainingFormFieldTemplate; context: { formField: formField }"
                ></ng-container>
            </ng-container>
        </ng-container>

        <ng-template #remainingFormFieldTemplate let-formField="formField">
            <p
                *ngIf="
                    { optionName: formField.configurationOption.name, key: 'optionDescription' }
                        | optionTranslation
                        | async as description
                "
            >
                {{ description }}
            </p>
            <ng-container *ngIf="formField.configurationOption.__typename === 'BooleanDealOption'">
                <mg-configuration-option-select-advanced
                    [configurationOption]="formField.configurationOption"
                    [formControl]="formField.formControl"
                ></mg-configuration-option-select-advanced>
            </ng-container>
            <ng-container
                *ngIf="formField.configurationOption.__typename === 'SelectableDealOption'"
                [ngSwitch]="formField.configurationOption.name"
            >
                <mg-configuration-option-select-duration
                    *ngSwitchCase="'duration'"
                    [formControl]="formField.formControl"
                    [configurationOption]="formField.configurationOption"
                ></mg-configuration-option-select-duration>
                <mg-configuration-option-select-km-per-year
                    *ngSwitchCase="'mileage'"
                    [formControl]="formField.formControl"
                    [configurationOption]="formField.configurationOption"
                ></mg-configuration-option-select-km-per-year>
                <mg-configuration-option-select-advanced-downpayment
                    *ngSwitchCase="'downpayment'"
                    [configurationOption]="formField.configurationOption"
                    [formControl]="formField.formControl"
                ></mg-configuration-option-select-advanced-downpayment>
                <mg-configuration-option-select-advanced-edition
                    *ngSwitchCase="'edition'"
                    [configurationOption]="formField.configurationOption"
                    [formControl]="formField.formControl"
                ></mg-configuration-option-select-advanced-edition>
                <mg-configuration-option-select-steeringwheel
                    *ngSwitchCase="'steeringWheel'"
                    [configurationOption]="formField.configurationOption"
                    [formControl]="formField.formControl"
                ></mg-configuration-option-select-steeringwheel>
                <mg-configuration-option-select-advanced-color
                    *ngSwitchCase="'paint'"
                    [configurationOption]="formField.configurationOption"
                    [formControl]="formField.formControl"
                ></mg-configuration-option-select-advanced-color>
                <mg-configuration-option-select-advanced-rims
                    *ngSwitchCase="'rims'"
                    [configurationOption]="formField.configurationOption"
                    [formControl]="formField.formControl"
                ></mg-configuration-option-select-advanced-rims>
                <ng-container *ngSwitchCase="'interior'">
                    <mg-configuration-option-select-advanced-interior
                        *ngIf="
                            (modelName$ | async) === 'Model 3' &&
                            formField.configurationOption.selectableValues.length === 2
                        "
                        [configurationOption]="formField.configurationOption"
                        [formControl]="formField.formControl"
                    ></mg-configuration-option-select-advanced-interior>
                    <mg-configuration-option-select-advanced-interior-triple-choice
                        *ngIf="
                            ['Model S', 'Model X'].includes(modelName$ | async) &&
                            formField.configurationOption.selectableValues.length === 3
                        "
                        [configurationOption]="formField.configurationOption"
                        [formControl]="formField.formControl"
                    ></mg-configuration-option-select-advanced-interior-triple-choice>
                    <mg-configuration-option-select-advanced
                        *ngIf="
                            ((modelName$ | async) !== 'Model 3' ||
                                formField.configurationOption.selectableValues.length !== 2) &&
                            (!['Model S', 'Model X'].includes(modelName$ | async) ||
                                formField.configurationOption.selectableValues.length !== 3)
                        "
                        [configurationOption]="formField.configurationOption"
                        [formControl]="formField.formControl"
                    ></mg-configuration-option-select-advanced>
                </ng-container>
                <ng-container *ngSwitchCase="'autopilot'">
                    <mg-configuration-option-select-advanced-fsd
                        *ngIf="useFsdGrowthModelComponent()"
                        [configurationOption]="formField.configurationOption"
                        [formControl]="formField.formControl"
                        [dealId]="configurationId"
                    ></mg-configuration-option-select-advanced-fsd>
                    <mg-configuration-option-select
                        *ngIf="!useFsdGrowthModelComponent()"
                        [configurationOption]="formField.configurationOption"
                        [formControl]="formField.formControl"
                    ></mg-configuration-option-select>
                </ng-container>
                <mg-configuration-option-select
                    *ngSwitchDefault
                    [formControl]="formField.formControl"
                    [configurationOption]="formField.configurationOption"
                ></mg-configuration-option-select>
            </ng-container>
        </ng-template>
        <div *ngIf="hasAccessories()" style="border: 0.125rem solid #eeeeee">
            <h3 style="background-color: #51bba0; color: #fff; padding: 0.875rem 2.75rem 0.875rem 1.5rem">
                Accessories
            </h3>
            <ng-container
                *ngFor="let formField of remainingFormFields$ | async | accessoryFilter; trackBy: trackFormField"
            >
                <mg-ui-card
                    [attr.data-id]="formField.id"
                    [attr.data-name]="formField.configurationOption.name"
                    [subtitle]="
                        { optionName: formField.configurationOption.name, key: 'subtitle' } | optionTranslation | async
                    "
                    [subtitleLink]="
                        { optionName: formField.configurationOption.name, key: 'subtitleLink' }
                            | optionTranslation
                            | async
                    "
                    [subtitleLinkLabel]="
                        { optionName: formField.configurationOption.name, key: 'subtitleLinkLabel' }
                            | optionTranslation
                            | async
                    "
                    [title]="
                        { optionName: formField.configurationOption.name, key: 'title' } | optionTranslation | async
                    "
                >
                    <mg-ui-modal [keys]="[formField.configurationOption.name]">
                        <mat-icon class="configurator-icon-modal">info_outline</mat-icon>
                    </mg-ui-modal>
                    <ng-container *ngTemplateOutlet="remainingFormFieldTemplate; context: { formField: formField }">
                    </ng-container>
                </mg-ui-card>
            </ng-container>
        </div>

        <ng-content></ng-content>
    </ng-container>
</mg-checkout-options-layout>
